import React from 'react';
import { FaBalanceScale, FaPhoneVolume } from 'react-icons/fa';
import { HiMiniBuildingOffice2 } from 'react-icons/hi2';
import { IoLocation } from 'react-icons/io5';
import { MdMarkEmailRead, MdOutlineLocalOffer } from 'react-icons/md';

const Contact = () => {
	return (
		<div id='contact' className='w-[90%] lg:w-[50%] h-auto scroll-mt-32'>
			<div className='p-6'>
				<h2 className='text-2xl font-bold text-white mb-4'>
					Contactez-nous
				</h2>

				{/* Siège social */}
				<div className='mb-4'>
					<div className='flex flex-row items-center justify-start text-lg font-semibold gap-1 text-[#AC9961]'>
						<IoLocation size={20} />
						<h3 className='text-lg font-semibold'>Siège social</h3>
					</div>
					<p className='text-white ml-6 text-sm'>
						5 Bd Abdellah Ben Yassine Imm Belledone, 5° étage Appt
						n°5 Casablanca, Maroc
					</p>
				</div>

				{/* Bureau */}
				<div className='mb-4'>
					<div className='flex flex-row items-center justify-start text-lg font-semibold gap-1 text-[#AC9961]'>
						<HiMiniBuildingOffice2 size={20} />
						<h3 className='text-lg font-semibold'>Bureau</h3>
					</div>

					<p className='text-white ml-6 text-sm'>
						Résidence Les Jardins de Belvédère, Appt C136 3° étage Im C, Rue SERGENT HILAIRE, Ain Borja Casablanca-Maroc
					</p>
				</div>

				{/* Téléphone */}
				<div className='mb-4'>
					<div className='flex flex-row items-center justify-start text-lg font-semibold gap-1 text-[#AC9961]'>
						<FaPhoneVolume size={20} />
						<h3 className='text-lg font-semibold'>Téléphone</h3>
					</div>
					<p className='text-white ml-6 text-sm'>
						<a href='tel:+212529061623' className='hover:underline'>+212 529061623</a>
					</p>
					<p className='text-white ml-6 text-sm'>
						<a href='tel:+212600997544' className='hover:underline'>+212 600997544</a>
					</p>
				</div>

				{/* Email */}
				<div className='mb-4'>
					<div className='flex flex-row items-center justify-start text-lg font-semibold gap-1 text-[#AC9961]'>
						<MdMarkEmailRead size={20} />
						<h3 className='text-lg font-semibold'>Email</h3>
					</div>
					<p className='text-white ml-6 text-sm'>
						<a
							href='mailto:cabinet.cfcae@gmail.com'
							className='text-white hover:underline'
						>
							cabinet.cfcae@gmail.com
						</a>
					</p>
				</div>

				{/* Slogan */}
				<div className='mb-4'>
					<div className='flex flex-row items-center justify-start text-lg font-semibold gap-1 text-[#AC9961]'>
						<MdOutlineLocalOffer size={20} />
						<h3 className='text-lg font-semibold'>Slogan</h3>
					</div>
					<p className='text-white ml-6 text-sm'>Se former, c'est avancer ! </p>
				</div>

				{/* Informations fiscales */}
				<div className='mb-4'>
					<div className='flex flex-row items-center justify-start text-lg font-semibold gap-1 text-[#AC9961]'>
						<FaBalanceScale size={20} />
						<h3 className='text-lg font-semibold'>Informations Fiscales</h3>
					</div>
					<p className='text-white ml-6 text-sm'>
						Cpt : AWB N° 007 780 0003919000000288 71
					</p>
					<p className='text-white ml-6 text-sm'>IF : 5352189</p>
					<p className='text-white ml-6 text-sm'>ICE : 003201158000002</p>
					<p className='text-white ml-6 text-sm'>PT : 3250209</p>
					<p className='text-white ml-6 text-sm'>RC : 566801</p>
				</div>
			</div>
		</div>
	);
};

export default Contact;